import http from "./HttpService";
const endpoint = process.env.VUE_APP_BASE_URL;

export const submitNewIban = (data, accountId) => {
  return http.post("/BankShebas/" + accountId, data, {
    baseURL: endpoint,
  });
};

export const submitNewCard = (data) => {
  return http.post("/BankCards", data, {
    baseURL: endpoint,
  });
};
